import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useGlobalContext } from "../Config";

function FormEditarPlantilla({
    visible,
    onHide,
    plantilla,
    onSaved
}) {
    const toast = useRef(null);
    const { urlContratos } = useGlobalContext();
    const [nombre, setNombre] = useState('');
    const [tipoMime, setTipoMime] = useState('');
    const [idAdjunto, setIdAdjunto] = useState(null);
    const [idTipoDocumento, setIdTipoDocumento] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setNombre(plantilla?.nombre ?? '');
        setTipoMime(plantilla?.tipo_mime ?? '');
        setIdAdjunto(plantilla?.idAdjunto ?? null);
        setIdTipoDocumento(plantilla?.idTipoDocumento ?? null);
    }, [plantilla]);

    const handleGuardar = async () => {
        if (!plantilla?.id) return;
        const idUsuario = sessionStorage.getItem('usuario_id') || '';
        try {
            setLoading(true);

            const url = `${urlContratos}editarPlantillaDocumento` +
                `?id=${encodeURIComponent(plantilla.id)}` +
                `&nombre=${encodeURIComponent(nombre)}` +
                `&tipoMime=${encodeURIComponent(tipoMime)}` +
                `&idAdjunto=${encodeURIComponent(idAdjunto ?? '')}` +
                `&idTipoDocumento=${encodeURIComponent(idTipoDocumento ?? '')}` +
                `&idUsuario=${encodeURIComponent(idUsuario)}`;

            const resp = await fetch(url, {
                method: 'PUT',
                credentials: 'include',
            });
            if (!resp.ok) {
                throw new Error(`Error al editar plantilla (${resp.status})`);
            }

            onSaved?.({
                id: plantilla.id,
                nombre,
                tipo_mime: tipoMime,
                idAdjunto,
                idTipoDocumento
            });
            toast.current?.show({
                severity: 'success',
                summary: 'Actualizada',
                detail: 'Plantilla editada exitosamente',
                life: 3000
            });
        } catch (err) {
            console.error('No se pudo editar la plantilla:', err);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo guardar la edición',
                life: 3500
            });
        } finally {
            setLoading(false);
        }
    };

    const footer = (
        <div className="flex justify-content-end mt-3">
            <Button
                label="Cancelar"
                icon="pi pi-times"
                className="p-button p-button-rounded p-button-outlined mr-2"
                onClick={onHide}
                disabled={loading}
            />
            <Button
                label="Guardar"
                icon={loading ? "pi pi-spin pi-spinner" : "pi pi-save"}
                className="p-button-success p-button-rounded p-button"
                raised
                onClick={handleGuardar}
                disabled={loading || !nombre || !tipoMime}
            />
        </div>
    );

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                header="Editar Plantilla"
                visible={visible}
                onHide={onHide}
                className="p-fluid product-dialog"
                modal
                footer={footer}
            >

                <div className="card">
                <h6 className="mb-3">Información de la Plantilla</h6>

                <span className="p-float-label mt-2 mb-3">
                    <InputText
                        id="nombre"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                    />
                    <label htmlFor="nombre">Nombre</label>
                </span>

                {/* <span className="p-float-label mt-2 mb-3">
                    <InputText
                        id="tipoMime"
                        value={tipoMime}
                        onChange={(e) => setTipoMime(e.target.value)}
                    />
                    <label htmlFor="tipoMime">Tipo MIME</label>
                </span> */}

                <div className="grid">
                    {/* <div className="col-12 md:col-6">
                        <span className="p-float-label mt-2 mb-3">
                            <InputNumber
                                id="idAdjunto"
                                value={idAdjunto}
                                onValueChange={(e) => setIdAdjunto(e.value)}
                                min={0}
                                useGrouping={false}
                            />
                            <label htmlFor="idAdjunto">ID Adjunto</label>
                        </span>
                    </div> */}
                    {/* <div className="col-12 md:col-6">
                        <span className="p-float-label mt-2 mb-3">
                            <InputNumber
                                id="idTipoDocumento"
                                value={idTipoDocumento}
                                onValueChange={(e) => setIdTipoDocumento(e.value)}
                                min={0}
                                useGrouping={false}
                            />
                            <label htmlFor="idTipoDocumento">ID Tipo Documento</label>
                        </span>
                    </div> */}
                </div>
            </div>
            </Dialog>
        </>
    );
}

export default FormEditarPlantilla;